<template>
  <div class="login-page">
    <div class="wrap">
      <img class="wrap-bg" src="@/assets/images/bg_wrap.png" alt="" />
      <img class="logo" src="@/assets/images/logo.png" alt="" />
    </div>
    <div class="content">
      <div class="title">{{ result.resultText }}</div>
      <div v-if="result.userId">
        <div class="flexbox userid_box">用户昵称:{{ result.nickName || '-' }}</div>
        <div class="flexbox userid_box">
          用户ID:{{ result.userId || '-' }}
          <div class="copy_box" @click="copy(result.userId, $event)">点击复制</div>
        </div>
      </div>
      <div v-if="result.resultSuccess" class="link">下载友邻少年APP即刻学习新概念课程</div>
      <div v-if="result.resultSuccess" class="action-btns">
        <div class="btn-down" @click="downApp"><span>去下载</span></div>
      </div>
      <UserInfoCopyCode />
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import UserInfoCopyCode from '../../userinfo-copycode'
import { bindUserMixin } from '../options'
import { pageArgs } from '@/utils'
import copyText from '@/utils/clipboard'

export default {
  name: 'user_bnxgn_bind',
  components: {
    UserInfoCopyCode
  },
  mixins: [Body, bindUserMixin],
  props: {
    query: Object
  },
  data() {
    const { bnxgn_code } = pageArgs.args()
    return {
      bnxgn_code,
      bindResult: {
        resultText: '查询暴虐新概念课程权益',
        resultSuccess: false
      }
    }
  },
  computed: {
    result() {
      return this.query || this.bindResult
    }
  },
  methods: {
    copy(code, $event) {
      const text = `${code || '-'}`
      copyText(text, $event)
    },
    // 本地有用户信息时，执行
    activated_hasToken() {
      this.bindUserByCode()
    },
    // 微信登录后，再次执行（watch: getWXUser.userId）watch_hasWXUser
    getWXUserAfter_getData() {
      this.bindUserByCode()
    },
    // 微信登录后，再次获取用户数据
    bindUserByCode() {
      const { bindResult } = this
      const { text, resultSuccess } = this.$route.query
      const code = this.bnxgn_code
      this.bnxgn_code = null // 标记清除
      console.log('[bindUserByCode]', code)
      if (text) {
        bindResult.resultText = text
      }
      if (resultSuccess) {
        bindResult.resultSuccess = true
      }
      this.bindUser({ code })
    },
    async bindUser(data) {
      const { bindResult } = this
      if (!data.code) {
        return
      }

      console.log('[bindUser]')

      // 2.2 绑定手机号后添加新概念权益（跳转到友邻）
      await this.do$bindAndAddPrivilege(data, bindResult)

      // // 1. 用户是否有新概念课程权益
      // await this.do$checkUserCoursePrivilege(data, bindResult)
      // if (bindResult.havePrivilege === false) return
      // // 2. 新概念是否有匹配的友邻少年ID（有权益时查询并绑定）
      // await this.do$isMatchYlyk(data, bindResult)
      // // bindResult.match = true // test
      // if (bindResult.match) {
      //   // 2.1 对应友邻少年ID是否有相应权益
      //   await this.do$ylykIsHavePirvilege(data, bindResult)
      //   // bindResult.ylykIsHavePirvilege = false
      //   if (bindResult.ylykIsHavePirvilege) {
      //     // 2.11 添加新概念权益
      //     await this.do$addPrivilege(data, bindResult)
      //   }
      // } else {
      //   // 2.2 绑定手机号后添加新概念权益（跳转到友邻）
      //   await this.do$bindAndAddPrivilege(data, bindResult)
      // }
    },
    downApp() {
      const link = document.createElement('a')
      link.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.zhuomogroup.ylyk'
      link.click()
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .wrap {
    display: flex;
    justify-content: center;
    position: relative;
    .wrap-bg {
      width: 3.6rem;
      height: 3.8rem;
      position: absolute;
      top: 0;
      right: 0;
    }
    .logo {
      width: 1.2rem;
      height: 1.2rem;
      margin-top: 1.61rem;
    }
  }
  .content {
    text-align: center;
    color: #000000;
    .title {
      font-size: 0.38rem;
      line-height: 0.53rem;
      margin-top: 1rem;
      font-weight: bold;
    }
    .userid_box {
      font-size: 0.36rem;
      line-height: 0.53rem;
      margin: 10px 0;
      justify-content: center;
      .copy_box {
        margin-left: 10px;
        font-size: 0.36px;
        background-color: #00b25a;
        color: #fff;
        padding: 2px 5px;
        border-radius: 5px;
      }
    }
    .link {
      font-size: 0.32rem;
      line-height: 0.45rem;
      margin-top: 0.31rem;
    }
  }
  .action-btns {
    display: flex;
    justify-content: center;
    margin-top: 2.8rem;
    .btn-down {
      width: 5.48rem;
      line-height: 0.88rem;
      background: #00b25a;
      border-radius: 0.08rem;
      span {
        font-size: 0.32rem;
        color: #ffffff;
        line-height: 0.45rem;
      }
    }
  }
}
</style>
